<template>
    <div>
        <card-header title="Client Database" icon="fa-users"></card-header>
        <card-container :padded="true" class="notice">
            <strong class="notice">Notice </strong>
            <i class="fa-regular fa-circle-exclamation"></i>
            The 24/7 Educational Services, Client Database contains confidential
            and proprietary information. The use of any information contained
            within the 24/7 Educational Services, Client Database, including
            disclosure, copying, printing, distribution, electronic conveyance
            of any type for any purpose other than 24/7 Educational Services
            business is prohibited.
        </card-container>

        <card-body>
            <card-list>
                <search-list-item @action="searchClient" />
                <div class="columns mx-2 my-0">
                    <div class="column is-two-thirds">
                        <b-field label="Sort By" label-position="inside">
                            <b-select expanded v-model="sortBy">
                                <option value="last_name">Last Name</option>
                                <option value="first_name">First Name</option>
                                <option value="created_at">Registration Date</option>
                                <option value="phone">Phone</option>
                                <option value="grade_level">Grade Level</option>
                                <option value="subject_area">Subject Area</option>
                                <option value="school">School</option>
                                <option value="district">District</option>
                                <!-- TODO: this can be added back as an option post-course migration -->
                                <!-- <option value="total_hours">Total Hours</option> -->
                            </b-select>
                        </b-field>
                    </div>
                    <div class="column is-one-third">
                        <div>
                            <b-radio v-model="sortOrder" native-value="asc">Ascending</b-radio>
                        </div>
                        <div>
                            <b-radio v-model="sortOrder" native-value="desc">Descending</b-radio>
                        </div>
                    </div>
                </div>
                <subheader-list-item title="Clients" icon="fa-users"></subheader-list-item>
                <reseller-client-tile
                    v-for="user in users"
                    :card="card"
                    :user="user"
                    @click="$openCard('user', { userId: user.id }, card)"
                    :active="(child && child.definition.component === 'user' && user.id === parseInt(child.props.userId))"
                />
            </card-list>
            <infinite-loading @infinite="loadClients">
                <div slot="no-more"></div>
                <div slot="no-results">No Records Found</div>
            </infinite-loading>
        </card-body>

        <card-footer>
            Showing <strong>{{ users.length | numeral('0,0') }}</strong> of <strong>{{ paging.total | numeral('0,0')
            }}</strong> total clients
        </card-footer>
    </div>
</template>

<script>
// tier items
import CardHeader from "@/TIER/components/CardHeader";
import CardContainer from "@/TIER/components/CardContainer";
import CardBody from "@/TIER/components/CardBody";
import SearchListItem from "@/TIER/components/SearchListItem";
import CardList from "@/TIER/components/CardList";
import CardSubheader from "@/TIER/components/CardSubheader";
import SubheaderListItem from "@/TIER/components/SubheaderListItem";
import CardFooter from "@/TIER/components/CardFooter";
// components
import ResellerClientTile from "../../components/tiles/ResellerClientTile";
// js
import { apiUrl } from "@/http_client";
import { axiosInstance as axios } from "@/http_client";

export default {
    props: ['card', 'child', 'props'],
    components: {
        // tier items
        CardFooter, CardContainer, CardHeader, CardBody, SearchListItem, CardList, CardSubheader, SubheaderListItem, SearchListItem,
        // components
        ResellerClientTile
    },
    data() {
        return {
            users: [],
            paging: {
                total: 0,
                start: 0,
            },
            sortBy: 'last_name',
            sortOrder: 'asc',
        };
    },
    methods: {
        formatUser(user) {
            // if no enrollments, set to 0
            if (!user.courseenrollments || !user.courseenrollments.length) {
                user.total_hours = 0;
                user.total_courses = 0;
                user.courses_started = 0;
                user.courses_completed = 0;
                return user;
            }
            // calc total hours
            user.total_hours = user.courseenrollments.reduce((total, enrollment) => {
                return total + enrollment.units;
            }, 0);
            // calc total courses
            user.total_courses = user.courseenrollments.length;
            // calc courses started
            user.courses_started = user.courseenrollments.reduce((total, enrollment) => {
                return total + (enrollment.logtime > 0 ? 1 : 0);
            }, 0);
            // calc courses completed
            user.courses_completed = user.courseenrollments.reduce((total, enrollment) => {
                return total + (enrollment.completed ? 1 : 0);
            }, 0);
            return user;
        },
        loadClients($state) {
            axios.get(`${apiUrl}resellers/clients/${this.paging.start}/30/${this.sortBy}/${this.sortOrder}`).then(response => {
                if (!response.data || !response.data.clients || !response.data.clients.length)
                    return this.$emit('loading', false);
                this.users.push(...response.data.clients.map(user => this.formatUser(user)));
                this.paging.total = response.data.total;
                this.paging.start += response.data.clients.length;
                if ($state) $state.loaded();
                if ($state && this.paging.start >= this.paging.total) {
                    $state.complete();
                }
                this.$emit('loading', false);
            });
        },
        searchClient(query) {
            this.$openCard('reseller-client-search', { query }, this.card);
        },
    },
    watch: {
        sortBy() {
            this.users = [];
            this.paging.start = 0;
            this.loadClients();
        },
        sortOrder() {
            this.users = [];
            this.paging.start = 0;
            this.loadClients();
        }
    },
}
</script>

<style lang="css" scoped>
.notice {
    background-color: #f2dede;
    border-color: #eed3d7;
    color: #b94a48;
}
</style>
